import React from 'react';
import './Button.scss';
import { LiaArrowRightSolid } from 'react-icons/lia';
import { Icon } from '@design-system';

export type ButtonProps = {
    color: 'marine' | 'green' | 'grey' | 'red' | 'yellow' | 'blue';
    iconColor?: 'white' | 'marine' | 'green' | 'grey' | 'red' | 'yellow' | 'blue';
    quickaccess?: boolean;
    size?: 'small' | 'fullwidth';
    variant?: 'primary' | 'secondary' | 'tertiary' | 'disabled';
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'forced-left' | 'right' | 'forced-right';
    iconSize?: number;
    secondaryIcon?: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = ({
    color,
    size,
    variant = 'primary',
    children,
    icon,
    iconColor = color,
    iconPosition = 'left',
    quickaccess,
    iconSize = 16,
    secondaryIcon,
    ...props
}) => {
    if (!quickaccess) {
        return (
            <button data-color={color} data-size={size} data-variant={variant} data-icon-position={iconPosition} {...props}>
                {icon && (iconPosition === 'left' || iconPosition === 'forced-left') && (
                    <Icon icon={icon} size={iconSize} color={iconColor} className={iconPosition === 'forced-left' ? 'forced-left' : ''} />
                )}
                {children}
                {icon && (iconPosition === 'right' || iconPosition === 'forced-right') && (
                    <Icon icon={icon} size={iconSize} color={iconColor} className={iconPosition === 'forced-right' ? 'forced-right' : ''} />
                )}
                {secondaryIcon && <Icon icon={secondaryIcon} size={14} color={iconColor} />}
            </button>
        );
    }

    return (
        <button data-quickaccess data-color={color} {...props}>
            <div className="left-content">
                <span className="custom-icon">{icon}</span>
                {children}
            </div>
            <span className="arrow">
                <Icon icon={<LiaArrowRightSolid />} size={36} color={iconColor} />
            </span>
        </button>
    );
};
